export const NEIGHBORHOOD_COVER_STRINGS = {
  title: 'You own a home in\n{neighborhoodName},\u00a0{state}',
  seeIfQualify: 'Get Started',
  learnMore: 'LEARN\u00a0MORE',
  orCall: 'Or Call',
};
